import { React } from 'react';
import { t } from '@lingui/macro';
import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import SiteDetail from '../site-detail-panel/SiteDetail';
import { siteFilterId, timeRangeFilterId } from '../../filters';

const title = t`Site Status`;

function SiteStatusBreakoutPanel() {
    return <SiteDetail />;
}

SiteStatusBreakoutPanel.propTypes = panelPropTypes;

SiteStatusBreakoutPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 50,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'SiteStatusBreakout',
    catalogEntry: {
        category: PANEL_CATEGORIES.SITE,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status breakdown for a selected site`,
        previewImage: STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId, siteFilterId],
        optional: [],
    },
})(SiteStatusBreakoutPanel);
